const AudioMap = require('AudioMap');

const State = cc.Enum({
    BUTTON: 'button',
    ANIMATING: 'animating',
    INFO: 'info',
})
cc.Class({
    extends: cc.Component,

    properties: {
        infoButton: cc.Button,
        closeButton: cc.Button,
        topSpine: sp.Skeleton,
        bottomSpine: sp.Skeleton,
        arrows: sp.Skeleton,
        pageView: cc.PageView,
        content: cc.Node,
        topButton: cc.Button,
        bottomButton: cc.Button,
        overlay: cc.Node
    },

    onLoad() {
        this.audioMap = cc.find('AudioMap').getComponent(AudioMap);

        this.topSpine.setCompleteListener(() => {
            switch(this.topSpine.animation) {
                case 'start':
                    this._changeState(State.INFO);
                    break;
                case 'end':
                    this._changeState(State.BUTTON);
                    break;
            }
        });
        this.arrows.setCompleteListener(() => {
            switch(this.topSpine.animation) {
                case '5end':
                    this.arrows.node.active = false;
                    break;
            }
        });
        this.originX = this.content.x;
        this.originY = this.content.y;
        this._changeState(State.BUTTON);
        this._playAnim('idle1');
        this.totalPages = 5;
    },

    start () {
    },

    _showOverlay () {
        this.overlay.active = true;
        this.overlay.opacity = 0;
        cc.tween(this.overlay).
            to(.5, { opacity: 127 }).
            start();
    },
    _hideOverlay () {
        this.overlay.opacity = 127;
        cc.tween(this.overlay).
            to(.5, { opacity: 0 }).
            call(() => {
                this.overlay.active = false;
            }).
            start();
    },

    _playAnim(anims, loop = true) {
        if (typeof anims === 'string') {
            anims = [anims];
        }
        for (let i = 0; i < anims.length; i++ ) {
            if (i === 0) {
                this.topSpine.setAnimation(0, anims[i], i === anims.length && loop);
                this.bottomSpine.setAnimation(0, anims[i], i === anims.length && loop);
            } else {
                this.topSpine.addAnimation(0, anims[i], i === anims.length && loop);
                this.bottomSpine.addAnimation(0, anims[i], i === anims.length && loop);
            }
        }
    },

    onButtonClicked () {
        this.audioMap.playSfx('introInfoOpen');
        this._showOverlay();
        this._changeState(State.ANIMATING);
        this._playAnim(['start', 'idle2']);
        this.arrows.node.active = true;
        this.arrows.setAnimation(0, '1start', false);
        this.arrows.addAnimation(0, '2idle1', true);

        cc.tween(this.content).
        delay(0.2).
        by(0.3, { x: -100, y: -150 }).
        start();

        this.scheduleOnce(() => {
            this.pageView.node.active = true;
            this.pageView.scrollToPage(0, 0);
            this._updateButtons(0);
        }, 0.4);

    },

    onCloseClicked () {
        this.audioMap.playSfx('intro InfoClose');
        this.scheduleOnce(() => {
            this._changeState(State.ANIMATING);
            this._playAnim(['end', 'idle1']);

            this._hideOverlay();
            this.arrows.setAnimation(0, '5end', false);
            cc.tween(this.content).
            delay(0.2).
            to(0.3, { x: this.originX,  y: this.originY }).
            start();

            this.scheduleOnce(() => {
                this.pageView.node.active = false;
            }, 0.1);
        }, .5);
    },

    nextButtonPressed () {
        if (this.isLocked) {
            return;
        }
        const page = this.pageView.getCurrentPageIndex();
        this.audioMap.playSfx('introSkipNextPage');

        if (page === this.totalPages - 1) {
            this.arrows.setAnimation(0, '3down3', false);
            this.arrows.addAnimation(0, '2idle3', true);
        } else {
            this.arrows.setAnimation(0, '3down2', false);
            this.arrows.addAnimation(0, '2idle2', true);
        }

        if (page < this.totalPages - 1) {
            if (page === this.totalPages - 2) {
                this.bottomButton.interactable = false;
            }
            this.topButton.interactable = true;
            this.pageView.scrollToPage(page + 1);
        }
    },

    previousButtonPressed () {
        if (this.isLocked) {
            return;
        }
        const page = this.pageView.getCurrentPageIndex();
        this.audioMap.playSfx('introSkipPrevPage');

        if (page === 0) {
            this.arrows.setAnimation(0, '4up2', false);
            this.arrows.addAnimation(0, '2idle1', true);
        } else {
            this.arrows.setAnimation(0, '4up1', false);
            this.arrows.addAnimation(0, '2idle2', true);
        }

        if (page > 0) {
            if (page === 1) {
                this.topButton.interactable = false;
            }
            this.bottomButton.interactable = true;
            this.pageView.scrollToPage(page - 1);

        }
    },

    _changeState(newState) {
        switch (newState) {
            case State.BUTTON:
                this.infoButton.interactable = true;
                this.closeButton.interactable = false;
                this.arrows.node.active = false;
                this.pageView.node.active = false;
                break;
            case State.ANIMATING:
                this.infoButton.interactable = false;
                this.closeButton.interactable = false;
                break;
            case State.INFO:
                this.infoButton.interactable = false;
                this.closeButton.interactable = true;
                break;
        }
        this.state = newState;
    },

    pageChangedListener() {
        this.audioMap.playOneShot(this.audioMap.uiButton);
        const page = this.pageView.getCurrentPageIndex();
        // this.node.emit('update', { page });
        this.scheduleOnce(() => {
            this._updateButtons(page);
        }, .3);
    },

    _updateButtons(page) {
        this.topButton.interactable = true;
        this.bottomButton.interactable = true;

        this.arrows.setAnimation(0, '2idle2', true);

        switch (page) {
            case 0:
                this.arrows.setAnimation(0, '2idle1', true);
                this.topButton.interactable = false;
                break;
            case this.totalPages - 1:
                this.arrows.setAnimation(0, '2idle3', true);
                this.bottomButton.interactable = false;
                break;
        }
    },
});
